export default {
    props: {
      value: {
        type: String
      },
      checked: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      type() {
        return this.$parent.type
      },
      active() {
        return this.$parent.value === this.value
      }
    },
    methods: {
      handleClick() {
        this.$parent.value = this.value
      }
    },
    created() {
      if (this.checked) this.$parent.value = this.value
    }
  }


/** WEBPACK FOOTER **
 ** ./src/radioBtn.vue
 **/